import React from "react";
import MonetaryUtils from "../../../../shared/utils/MonetaryUtils";
import DateUtils from "../../../../shared/utils/DateUtils";
import IconAction from "../../../../shared/components/generic/button/icon-action/icon-action";

export const adjustmentColumnsConfig = ({
    onEdit,
    onDelete
}) => [
    {
        key: "effectiveStartDate",
        label: "Início da vigência",
        width: "18%",
        render: row => (
            <span className="adjustment__effective-start-date">
                {DateUtils.formatDateToBrazilian(row.effectiveStartDate)}
            </span>
        )
    },
    {
        key: "effectiveEndDate",
        label: "Término da vigência",
        width: "18%",
        render: row => DateUtils.formatDateToBrazilian(row.effectiveEndDate)
    },
    {
        key: "adjustment",
        label: "% Reajuste",
        width: "18%",
        render: row => (
            <span className="adjustment__value">
                {MonetaryUtils.formatPercentage(row.adjustment)}
            </span>
        )
    },
    {
        key: "createdAt",
        label: "Data de criação",
        width: "17%",
        render: row => DateUtils.formatDateToBrazilian(row.createdAt)
    },
    {
        key: "updatedAt",
        label: "Data da Última Atualização",
        width: "17%",
        render: row => DateUtils.formatDateToBrazilian(row.updatedAt)
    },
    {
        key: "actions",
        label: "Ações",
        width: "12%",
        render: row => {
            const hasVigencyStarted = !DateUtils.isDateAfterToday(row.effectiveStartDate);

            return (
                <IconAction
                    row={row}
                    actions={[
                        {
                            key: "edit",
                            variant: "edit",
                            title: hasVigencyStarted ? "Vigência encerrada" : "Editar",
                            ariaLabel: hasVigencyStarted ? "Vigência encerrada" : "Editar",
                            disabled: hasVigencyStarted,
                            onClick: onEdit
                        },
                        {
                            key: "delete",
                            variant: "delete",
                            title: hasVigencyStarted ? "Vigência encerrada" : "Excluir",
                            ariaLabel: hasVigencyStarted ? "Vigência encerrada" : "Excluir",
                            disabled: hasVigencyStarted,
                            onClick: onDelete
                        }
                    ]}
                />
            );
        }
    }
];